import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from 'react-i18next';

export default function Loading() {
    const { t } = useTranslation()
    return (
        <div className="content h-100">
            <div className="w-100 h-100 d-flex align-items-center justify-content-center loading">
                <FontAwesomeIcon icon={faSpinner} size="2x" spin /> <span className="ms-2">{t('loading')}</span>
            </div>
        </div>
    )
}